"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppConfig = void 0;
var _react = require("react");
var _contexts = require("../contexts");
const useAppConfig = () => (0, _react.useContext)(_contexts.appConfigContext);
exports.useAppConfig = useAppConfig;
